import { Dispatch, SetStateAction, useCallback } from "react";
import { useAsyncResult } from "../../Hooks/UseAsyncResult";
import { fetchPipelines, fetchPipelineWithUserData } from "../../Api/ado.api";

export function useFetchPipelineRuns(
  pipelineId: number | null | undefined,
  configFileName: string,
  setError: Dispatch<SetStateAction<any>>,
) {
  const func = useCallback(
    async (_disposable, _force) => {
      if (!pipelineId) {
        return [];
      }

      const useData = await fetchPipelineWithUserData(pipelineId);
      const runs = await fetchPipelines(pipelineId);
      const enrichedRuns = runs.map((run) => {
        const userData = useData.find((data: any) => data.id === run.id);
        return {
          ...userData,
          ...run,
        };
      });
      const filteredRuns = (enrichedRuns || []).filter((run: any) => {
        const runConfigFileName = run.templateParameters?.ConfigSpecFileName;
        return runConfigFileName === configFileName;
      });
      return filteredRuns.slice(0, 10);
    },
    [configFileName, pipelineId],
  );

  return useAsyncResult({
    func,
    setError,
  });
}
